/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesCommunications.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { ReactComponent as AtIcon } from 'assets/icons/at.svg';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import PreferencesCol from 'components/layouts/Preferences/shared/PreferencesCol';
import PreferencesSectionHeader from 'components/layouts/Preferences/shared/PreferencesSectionHeader';
import PreferencesRow from 'components/layouts/Preferences/shared/PreferencesRow';
import PreferencesRowLabel from 'components/layouts/Preferences/shared/PreferencesRowLabel';
import {
  canViewDocumentDelivery,
  isEligibleToViewSubscriptions
} from 'state/view/ViewSelectors';
import { paperlessPageEnabled } from 'services/FeatureFlags';

const DesktopCommunications = ({
  eligibleToViewSubscriptions,
  canViewDocumentDelivery
}) => (
  <Fragment>
    {canViewDocumentDelivery && (
      <PreferencesRow>
        <PreferencesCol col={3}>
          <PreferencesRowLabel
            className="preferences-row-label"
            label={
              paperlessPageEnabled()
                ?'Paperless Preferences' 
                : 'Document Delivery'
            }
          />
        </PreferencesCol>

        <PreferencesCol col={6}>
          <div className="preferences-communications-text">
            Select e-delivery for important documents such as Statements and
            Confirmations.
          </div>
        </PreferencesCol>

        <PreferencesCol col={3}>
          <Link
            className="preferences-communications-link"
            id="e2e-profile-document-delivery-link"
            to="/profile/document-delivery">
            {paperlessPageEnabled() ? (
              <span data-testid='paperless-preferences'>Edit Paperless Preferences</span>
            ) : (
              <span data-testid='document-delivery'>Edit Document Delivery</span>
            )}
          </Link>
        </PreferencesCol>
      </PreferencesRow>
    )}
    <PreferencesRow>
      <PreferencesCol col={3}>
        <PreferencesRowLabel label="Subscriptions" />
      </PreferencesCol>

      <PreferencesCol col={6}>
        <div className="preferences-communications-text">
          Sign up for email notifications and newsletters on relevant investing
          topics.
        </div>
      </PreferencesCol>

      <PreferencesCol col={3}>
        {eligibleToViewSubscriptions && (
          <Link
            className="preferences-communications-link"
            id="e2e-profile-subscriptions-link"
            data-testid="e2e-profile-subscriptions-link"
            to="profile/subscriptions">
            Manage Subscriptions
          </Link>
        )}
      </PreferencesCol>
    </PreferencesRow>
  </Fragment>
);

const MobileCommunications = ({
  eligibleToViewSubscriptions,
  canViewDocumentDelivery
}) => (
  <Fragment>
    {canViewDocumentDelivery && (
      <PreferencesRow>
        <PreferencesCol col={12}>
          <Link
            className="preferences-communications-link"
            to="/profile/document-delivery">
            {paperlessPageEnabled() ? (
              <span data-testid='paperless-preferences-mobileCommunication'>Paperless Preferences</span>
            ) : (
              <span data-testid='document-delivery-mobileCommunication'>Document Delivery</span>
            )}
            <ChevronRight className="preferences-chevron-right" />
          </Link>
        </PreferencesCol>
      </PreferencesRow>
    )}
    <PreferencesRow>
      <PreferencesCol col={12}>
        {eligibleToViewSubscriptions && (
          <Link
            className="preferences-communications-link"
            to="profile/subscriptions">
            Manage Subscriptions
            <ChevronRight className="preferences-chevron-right" />
          </Link>
        )}
      </PreferencesCol>
    </PreferencesRow>
  </Fragment>
);

const PreferencesCommunications = ({
  eligibleToViewSubscriptions,
  canViewDocumentDelivery,
  hasOnlyViewOnly,
  isDesktopLayout
}) => (
  <div className="preferences-communications">
    <PreferencesSectionHeader Icon={AtIcon} text="Communications" />
    {isDesktopLayout ? (
      <DesktopCommunications
        eligibleToViewSubscriptions={eligibleToViewSubscriptions}
        hasOnlyViewOnly={hasOnlyViewOnly}
        canViewDocumentDelivery={canViewDocumentDelivery}
      />
    ) : (
      <MobileCommunications
        eligibleToViewSubscriptions={eligibleToViewSubscriptions}
        hasOnlyViewOnly={hasOnlyViewOnly}
        canViewDocumentDelivery={canViewDocumentDelivery}
      />
    )}
  </div>
);

const mapStateToProps = (state) => ({
  isDesktopLayout: state.view.isDesktopLayout,
  eligibleToViewSubscriptions: isEligibleToViewSubscriptions(state),
  canViewDocumentDelivery: canViewDocumentDelivery(state)
});

export default connect(mapStateToProps)(PreferencesCommunications);
